import { createContext } from "@videojs/element/context";
/** @internal */
const dialogContext = createContext(Symbol("@videojs/dialog"));
//#endregion
export { dialogContext };
